import Property from "../Property";

describe("Entity model", () => {
  test("belongsTo relations", () => {
    expect(Property.belongsTo.map(relation => relation.name)).toMatchSnapshot();
  });
});
